import { post } from '../../../../util/api';

export const updateDynamicSearchOptions = async () => {
  try {
    const documents = await post('/api/firebase/get-documents', { collectionName: 'tags' });
    const searchableStrings = documents.map((doc) => decodeURIComponent(doc.id));
    window.sessionStorage.setItem('dynamicSearchOptions', JSON.stringify(searchableStrings));
    return searchableStrings;
  } catch (e) {}
};
